// @apiglobal scope
import * as typedrequest from '@api.global/typedrequest';
import * as typedrequestInterfaces from '@api.global/typedrequest-interfaces';

export { typedrequest, typedrequestInterfaces };

// @pushrocks scope
import * as smartdelay from '@push.rocks/smartdelay';
import * as smartjson from '@push.rocks/smartjson';
import * as smartpromise from '@push.rocks/smartpromise';
import * as smartrx from '@push.rocks/smartrx';
import * as smartstring from '@push.rocks/smartstring';
import * as smarturl from '@push.rocks/smarturl';

export { smartdelay, smartjson, smartpromise, smartrx, smartstring, smarturl };

// SmartServe - required for server-side WebSocket support
export type { SmartServe, IWebSocketPeer } from '@push.rocks/smartserve';
